import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { UserContext } from './UserContext/UserContext';
var INITIAL_SEARCH_CONTEXT = {
  searchActive: false,
  searchPhrase: '',
  searchCategory: 'All'
};

var INITIAL_CONTEXT = _objectSpread(_objectSpread({
  activeKey: '',
  chromelessFloating: false,
  expanded: false,
  banner: false,
  hasLinks: true
}, INITIAL_SEARCH_CONTEXT), {}, {
  searchResultsRef: /*#__PURE__*/React.createRef()
});

var noop = function noop() {// empty placeholder function for context init
};

var defaultValue = _objectSpread(_objectSpread({}, INITIAL_CONTEXT), {}, {
  resetSearch: noop,
  setChromeless: noop,
  setChromelessFloating: noop,
  setExpanded: noop,
  setHasOpenMenu: noop,
  setSearchActive: noop,
  setSearchCategory: noop,
  setSearchPhrase: noop,
  setSearchResultsRef: noop
});

export var Context = React.createContext(defaultValue);
Context.displayName = 'CommonChromeContext';

var CommonChromeContextProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(CommonChromeContextProvider, _React$Component);

  var _super = _createSuper(CommonChromeContextProvider);

  function CommonChromeContextProvider(props) {
    var _this;

    _classCallCheck(this, CommonChromeContextProvider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "resetSearch", function () {
      _this.setState(INITIAL_SEARCH_CONTEXT);
    });

    _defineProperty(_assertThisInitialized(_this), "setterFor", function (propName) {
      return function (propValue) {
        return _this.setState(_defineProperty({}, propName, propValue));
      };
    });

    _this.state = INITIAL_CONTEXT;
    return _this;
  }

  _createClass(CommonChromeContextProvider, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(UserContext.Consumer, null, function (userContext) {
        return /*#__PURE__*/React.createElement(Context.Provider, {
          value: {
            activeKey: _this2.props.activeKey,
            chromeless: _this2.props.chromeless,
            chromelessFloating: _this2.state.chromelessFloating,
            expanded: userContext.navigation.expanded,
            banner: _this2.props.banner,
            hasOpenMenu: _this2.state.hasOpenMenu,
            links: _this2.props.links,
            hasLinks: _this2.props.hasLinks,
            LinkWrapper: _this2.props.LinkWrapper,
            searchActive: _this2.state.searchActive,
            searchCategory: _this2.state.searchCategory,
            searchPhrase: _this2.state.searchPhrase,
            searchResultsRef: _this2.state.searchResultsRef,
            resetSearch: _this2.resetSearch,
            setChromelessFloating: _this2.setterFor('chromelessFloating'),
            setExpanded: userContext.setSidebarExpanded,
            setHasOpenMenu: _this2.setterFor('hasOpenMenu'),
            setSearchActive: _this2.setterFor('searchActive'),
            setSearchCategory: _this2.setterFor('searchCategory'),
            setSearchPhrase: _this2.setterFor('searchPhrase'),
            setSearchResultsRef: _this2.setterFor('searchResultsRef')
          }
        }, _this2.props.children);
      });
    }
  }]);

  return CommonChromeContextProvider;
}(React.Component);

export var ContextProvider = CommonChromeContextProvider;
export var ContextConsumer = Context.Consumer;